import React, { useState } from 'react'
import ClearIcon from '@mui/icons-material/Clear'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import {
  Box,
  Divider,
  Fade,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material'
import { styled } from '@mui/system'
import { useAppStore } from '../store/useAppStore'
import { useParamsFromURL } from '../hooks/useParamsFromURL'
import { useTranslation } from 'react-i18next'

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  '& svg': {
    color: theme.palette.text.primary,
  },
}))

const StyledMenuItem = styled(MenuItem)({
  fontSize: '1.25rem',
})

const Header = () => {
  const setAlertDialog = useAppStore((state) => state.setAlertDialog)
  const [anchorEl, setAnchorEl] = useState(null)

  const { vehicleId, allowClose, webView, customTab } = useParamsFromURL([
    'vehicleId',
    'allowClose',
    'webView',
    'customTab',
  ])

  const { t } = useTranslation()

  const handleButtonClick = (event: {
    currentTarget: React.SetStateAction<null>
  }) => setAnchorEl(event.currentTarget)
  const handleClose = () => setAnchorEl(null)

  return (
    <>
      <Box
        sx={(theme) => ({
          display: 'flex',
          justifyContent: 'space-between',
          padding: theme.spacing(1),
          backgroundColor: '#fff',
          boxShadow: '0px 0px 2px rgba(0, 0, 0, 0.08)',
        })}
      >
        <Box display="flex" alignItems="center">
          {allowClose === 'true' && (
            <StyledIconButton
              size="small"
              onClick={() => {
                if (window.Android) {
                  window.Android.cancelVehicleDamageRegistrationApp()
                  customTab === 'true' && window.close()
                }
              }}
            >
              <ClearIcon />
            </StyledIconButton>
          )}
          <Typography
            variant="h1"
            sx={(theme) => ({
              marginLeft: theme.spacing(1),
            })}
          >
            {t('common.damage_registration')}
          </Typography>
        </Box>
        <StyledIconButton
          size="small"
          aria-controls="menu"
          aria-haspopup="true"
          onClick={handleButtonClick}
        >
          <MoreVertIcon />
        </StyledIconButton>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          BackdropProps={{
            timeout: 500,
            style: {
              backgroundColor: 'rgba(0, 0, 0, 0.5)', // Adjust background color
            },
          }}
          keepMounted
          TransitionComponent={Fade}
        >
          <StyledMenuItem
            onClick={() => {
              handleClose()
              setAlertDialog({
                open: true,
                header: t('header.license_plate_information'),
                message: vehicleId,
              })
            }}
          >
            {t('header.view_license_plate')}
          </StyledMenuItem>
          <StyledMenuItem onClick={handleClose}>FAQ</StyledMenuItem>
          {allowClose === 'true' && (
            <StyledMenuItem
              onClick={() => {
                handleClose()
                if (webView === 'true') {
                  if (window.Android) {
                    window.Android.cancelVehicleDamageRegistrationApp()
                    customTab === 'true' && window.close()
                  }
                } else {
                  window.close()
                }
              }}
            >
              {t('header.close')}
            </StyledMenuItem>
          )}
          <Divider sx={{ my: 2 }} />
          <Typography
            variant="body2"
            sx={{ textAlign: 'center', cursor: 'default' }}
          >
            {t('header.version', {
              number: process.env.REACT_APP_VERSION,
            })}
          </Typography>
        </Menu>
      </Box>
      <Divider sx={{ backgroundColor: '#F1f1f1' }} />
    </>
  )
}

export default Header
